import { type ButtonStyleSize, type ButtonStyleType } from './types';

export const buttonStyles = {
  base: 'inline-flex items-center justify-center transition-all duration-200 text-center active:focus:ring-4 ring-[#8FB7F9]',
  styleSize: {
    'XS-24': 'h-[24px] px-2 rounded-sm text-sm font-bold leading-none',
    'S-32': 'h-[32px] px-3 rounded-lg text-sm font-bold leading-none',
    'M-40': 'h-[40px] px-6 rounded-xl text-base font-bold leading-tight',
  } satisfies Record<ButtonStyleSize, string>,

  variants: {
    basic: [
      'bg-[#F0F0F0] text-black',
      'enabled:hover:bg-[#D9D9D9]',
      'enabled:active:bg-[#BFBFBF]',
      'disabled:bg-[#F0F0F0] disabled:text-[#BFBFBF]',
    ].join(' '),
    primary: [
      'bg-[#3C78F4] text-white',
      'enabled:hover:bg-[#2D64DC]',
      'enabled:active:bg-[#2254C5]',
      'disabled:bg-[#F0F0F0] disabled:text-[#BFBFBF]',
    ].join(' '),
    'outline-primary': [
      'bg-white text-[#3C78F4] border-[1px] border-solid border-[#3C78F4]',
      'enabled:hover:bg-[#D0DFFC]',
      'enabled:active:bg-[#8FB7F9]',
      'disabled:bg-white disabled:text-[#BFBFBF] disabled:border-[#D9D9D9]',
    ].join(' '),
    'outline-basic': [
      'bg-transparent text-black border-[1px] border-solid border-[#D9D9D9]',
      'enabled:hover:bg-[#0000000D]',
      'enabled:active:bg-[#0000001A]',
      'disabled:bg-[D9D9D9] disabled:text-[#BFBFBF] disabled:border-[#D9D9D9]',
    ].join(' '),
    'text-primary': [
      'bg-transparent text-[#3C78F4] shadow-none',
      'enabled:hover:bg-[#D0DFFC]',
      'enabled:active:bg-[#8FB7F9]',
      'disabled:bg-transparent disabled:text-[#BFBFBF]',
    ].join(' '),
    'text-basic': [
      'bg-transparent text-black shadow-none',
      'enabled:hover:bg-[#0000000D]',
      'enabled:active:bg-[#0000001A]',
      'disabled:bg-transparent disabled:text-[#BFBFBF]',
    ].join(' '),
    destructive: [
      'bg-[#D15445] text-white',
      'enabled:hover:bg-[#B94335]',
      'enabled:active:bg-[#A0392C]',
      'disabled:bg-[#F0F0F0] disabled:text-[#BFBFBF]',
    ].join(' '),
    'outline-destructive': [
      'bg-white text-[#D15445] border-[1px] border-solid border-[#D15445]',
      'enabled:hover:bg-[#F8D7D3]',
      'enabled:active:bg-[#EF9D94]',
      'disabled:bg-white disabled:text-[#BFBFBF] disabled:border-[#D9D9D9]',
    ].join(' '),
    'text-destructive': [
      'bg-white text-[#D15445] shadow-none',
      'enabled:hover:bg-[#F8D7D3]',
      'enabled:active:bg-[#EF9D94]',
      'disabled:bg-white disabled:text-[#BFBFBF]',
    ].join(' '),
    tonal: [
      'bg-[#E6F4FF] text-[#3C78F4] ',
      'enabled:hover:bg-[#D0DFFC]',
      'enabled:active:bg-[#8FB7F9]',
      'disabled:bg-[#F0F0F0] disabled:text-[#BFBFBF]',
    ].join(' '),
    'tonal-destructive': [
      'bg-[#FCEDEB] text-[#D15445]',
      'enabled:hover:bg-[#F8D7D3]',
      'enabled:active:bg-[#EF9D94]',
      'disabled:bg-[#F0F0F0] disabled:text-[#BFBFBF]',
    ].join(' '),
  } satisfies Record<ButtonStyleType, string>,
} as const;

export const buttonIconStyle = {
  color: {
    basic: '#101010',
    primary: '#ffffff',
    destructive: '#d15445',
    'outline-basic': '#101010',
    'outline-destructive': '#D15445',
    'outline-primary': '#3c78f4',
    'text-basic': '#101010',
    'text-destructive': '#d15445',
    'text-primary': '#3c78f4',
    'tonal-destructive': '#d15445',
    tonal: '#3c78f4',
  } satisfies Record<ButtonStyleType, string>,
} as const;
